<template>
    <div
            class="field__container"
         :class="{'field__container--no-label': !title || !labelFor, 'field__container--error': errorMessage, 'field__container--mandatory': required}">

        <slot name="label">
            <label
                    v-if="title && labelFor"
                    class="form__label"
                    :for="labelFor"
                    :class="{'form__label--mandatory': required}"
            >
                {{ title }}
            </label>
            <span class="tooltip" v-if="description">
                <i class="icon-info-tooltip icon--primary tooltip__icon" v-click-outside="hideTooltip" v-on:click="showTooltip"></i>
                <span class="tooltip__info" v-if="tooltipVisible">
                    {{ description }}
                </span>
            </span>
        </slot>

        <slot name="input"/>

        <div v-if="helpText" class="field__help-text">
            {{ helpText}}
        </div>

        <slot name="error">
			<span
                    v-if="errorMessage"
                    class="form__error"
            >
				{{ errorMessage }}
			</span>
        </slot>

    </div>
</template>

<script>
    export default {
        name: 'Field',
        props: {
            title: {
                type: String,
            },
            description: {
                type: String,
            },
            helpText: {
                type: String,
            },
            value: {
            },
            maxLength: {
            },
            labelFor: {
                type: String,
            },
            required: {
                type: Boolean,
            },
            errorMessage: {
                type: String,
            },
        },
        data: function(){
            return {
                tooltipVisible: false,
            };
        },
        methods: {
            showTooltip: function(e) {
                e.preventDefault;
                this.tooltipVisible = true;
            },
            hideTooltip: function(e) {
                e.preventDefault;
                this.tooltipVisible = false;
            },
        }
    }

    Vue.directive('click-outside', {
        bind: function (el, binding, vnode) {
            el.clickOutsideEvent = function (event) {
                // here I check that click was outside the el and his childrens
                if (!(el == event.target || el.contains(event.target))) {
                    // and if it did, call method provided in attribute value
                    vnode.context[binding.expression](event);
                }
            };
            document.body.addEventListener('click', el.clickOutsideEvent)
        },
        unbind: function (el) {
            document.body.removeEventListener('click', el.clickOutsideEvent)
        },
    });
</script>


// WEBPACK FOOTER //
// src/modules/form/components/fields/Field.vue